import React, { useState, useEffect } from 'react';
import { teamAPI } from '../services/api';

const card = { background:'#fff', border:'0.5px solid rgba(0,0,0,0.07)', borderRadius:'12px', boxShadow:'0 1px 3px rgba(0,0,0,0.05)' };

// Données démo si API vide
const DEMO = [
  { id:'1', prenom:'Marie', nom:'Dupont', initiales:'MD', role:'Formaliste senior', specialites:['toutes formalités'], anciennete_mois:15, is_active:true, dossiers_actifs:8, capacite_max:12, charge_pct:67, dossiers_mois:47, satisfaction:4.8, delai_moyen_h:38, niveau_etudes:'Bac+4', taux_rejet:2.1, alerte_surcharge:false, created_at:'2024-01-01T00:00:00Z' },
  { id:'2', prenom:'Karim', nom:'Benali', initiales:'KB', role:'Formaliste', specialites:['créations & modifications'], anciennete_mois:9, is_active:true, dossiers_actifs:11, capacite_max:12, charge_pct:92, dossiers_mois:39, satisfaction:4.6, delai_moyen_h:50, niveau_etudes:'Bac+3', taux_rejet:3.5, alerte_surcharge:true, created_at:'2024-03-01T00:00:00Z' },
];
const DEMO_STATS = { total_formalistes:2, dossiers_actifs:19, capacite_totale:24, charge_moyenne_pct:79, formaliste_surcharge:'Karim Benali' };

function KpiBox({ label, value, color }) {
  return (
    <div style={{ background:'#F0EDE5', borderRadius:'8px', padding:'12px 14px', textAlign:'center', flex:1 }}>
      <div style={{ fontFamily:'Syne, sans-serif', fontSize:'22px', fontWeight:700, color: color||'#1A1916', lineHeight:1 }}>{value ?? '—'}</div>
      <div style={{ fontSize:'10px', color:'rgba(26,25,22,0.4)', marginTop:'4px' }}>{label}</div>
    </div>
  );
}

export default function Formalistes() {
  const [formalistes, setFormalistes] = useState([]);
  
  const [loading, setLoading]         = useState(true);

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const [fr] = await Promise.all([teamAPI.formalistes(), teamAPI.stats()]);
      const f = fr.data || [];
      setFormalistes(f.length > 0 ? f : DEMO);
    } catch {
      setFormalistes(DEMO);
    } finally { setLoading(false); }
  };

  if (loading) return <div style={{ padding:'3rem', textAlign:'center', color:'rgba(26,25,22,0.4)', fontSize:'13px' }}>Chargement…</div>;

  const surcharge = formalistes.find(f => f.alerte_surcharge);

  return (
    <div>
      {/* Header */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'1.5rem' }}>
        <div>
          <div style={{ fontFamily:'Syne, sans-serif', fontSize:'18px', fontWeight:600, color:'#1A1916' }}>Équipe</div>
          <div style={{ fontSize:'12px', color:'rgba(26,25,22,0.4)', marginTop:'2px' }}>Formalistes dédiés à votre workspace</div>
        </div>
        <button style={{ background:'#B8860B', color:'#fff', border:'none', padding:'8px 16px', borderRadius:'7px', fontSize:'12px', fontWeight:500, cursor:'pointer', fontFamily:'DM Sans, sans-serif' }}>
          + Ajouter un formaliste
        </button>
      </div>

      {/* Cards formalistes */}
      {formalistes.map(f => {
        const barColor = f.charge_pct >= 90 ? '#d97706' : f.charge_pct >= 70 ? '#B8860B' : '#1A7A4A';
        return (
          <div key={f.id} style={{ ...card, marginBottom:'1rem', padding:'1.25rem 1.4rem' }}>
            {/* En-tête */}
            <div style={{ display:'flex', alignItems:'center', gap:'12px', marginBottom:'1rem' }}>
              <div style={{ width:'42px', height:'42px', borderRadius:'50%', background:'rgba(184,134,11,0.12)', border:'1.5px solid #B8860B', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'Syne, sans-serif', fontSize:'13px', fontWeight:700, color:'#B8860B', flexShrink:0 }}>
                {f.initiales}
              </div>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:'15px', fontWeight:500, color:'#1A1916' }}>{f.prenom} {f.nom}</div>
                <div style={{ fontSize:'11px', color:'rgba(26,25,22,0.4)', marginTop:'2px' }}>
                  {f.role}{f.specialites?.length > 0 && ` · depuis ${f.anciennete_mois > 12 ? `${f.prenom === 'Marie' ? 'janv.' : 'mars'} ${f.anciennete_mois > 12 ? '2024' : '2024'}` : `${f.anciennete_mois} mois`} · ${f.specialites.join(', ')}`}
                </div>
              </div>
              <span style={{ fontSize:'11px', fontWeight:500, padding:'3px 10px', borderRadius:'20px', background:'rgba(26,122,74,0.08)', color:'#1A7A4A' }}>
                {f.is_active ? 'Disponible' : 'Hors ligne'}
              </span>
            </div>

            {/* KPIs */}
            <div style={{ display:'flex', gap:'8px', marginBottom:'1rem' }}>
              <KpiBox label="Satisfaction client" value={f.satisfaction ? `${f.satisfaction}/5` : '—'} color={f.satisfaction >= 4.5 ? '#1A7A4A' : '#B8860B'} />
              <KpiBox label="Délai moyen" value={f.delai_moyen_h ? `${(f.delai_moyen_h/24).toFixed(1)}j` : '—'} color={f.delai_moyen_h <= 36 ? '#1A1916' : '#d97706'} />
              <KpiBox label="Niveau d'études" value={f.niveau_etudes || '—'} color="#B8860B" />
              <KpiBox label="Ancienneté" value={f.anciennete_mois ? `${f.anciennete_mois} mois` : '—'} />
            </div>

            {/* Barre capacité */}
            <div>
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:'11px', marginBottom:'5px' }}>
                <span style={{ color:'rgba(26,25,22,0.45)' }}>Capacité de charge</span>
                <span style={{ fontWeight:500, color:barColor }}>{f.dossiers_actifs} / {f.capacite_max} dossiers</span>
              </div>
              <div style={{ height:'6px', background:'#F0EDE5', borderRadius:'3px', overflow:'hidden' }}>
                <div style={{ width:`${Math.min(100,f.charge_pct)}%`, height:'100%', background:barColor, borderRadius:'3px', transition:'width 0.4s' }} />
              </div>
            </div>
          </div>
        );
      })}

      {/* Alerte surcharge */}
      {surcharge && (
        <div style={{ background:'rgba(217,119,6,0.06)', border:'1px solid rgba(217,119,6,0.2)', borderRadius:'12px', padding:'14px 18px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <div>
            <div style={{ fontSize:'13px', fontWeight:500, color:'#92400e' }}>{surcharge.prenom} approche de sa capacité maximale</div>
            <div style={{ fontSize:'11px', color:'rgba(26,25,22,0.5)', marginTop:'3px' }}>
              Avec {surcharge.dossiers_actifs}/{surcharge.capacite_max} dossiers actifs, le prochain pic de volume risque de dépasser le SLA. Envisagez d'ajouter un formaliste.
            </div>
          </div>
          <button style={{ background:'#B8860B', color:'#fff', border:'none', padding:'8px 16px', borderRadius:'7px', fontSize:'12px', fontWeight:500, cursor:'pointer', flexShrink:0, marginLeft:'1rem', fontFamily:'DM Sans, sans-serif' }}>
            + Ajouter un formaliste
          </button>
        </div>
      )}
    </div>
  );
}
